import React from "react";
import { Sparkles } from "lucide-react";
import { useT } from "../../lib/i18n";

export const NoCoperto = () => {
  const { t } = useT();
  return (
    <section
      data-testid="no-coperto-banner"
      className="relative bg-[#1E3A5D] text-white py-10 sm:py-14 overflow-hidden"
    >
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#B59410] to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#B59410] to-transparent" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 mb-4">
          <Sparkles className="w-4 h-4 text-[#E8C765]" />
          <span className="font-display text-[11px] sm:text-xs tracking-[0.32em] text-[#E8C765] font-semibold">
            {t("noCoperto.eyebrow")}
          </span>
          <Sparkles className="w-4 h-4 text-[#E8C765]" />
        </div>
        <p className="font-script text-5xl sm:text-6xl lg:text-7xl leading-[1] text-white">
          {t("noCoperto.title")}
        </p>
        <p className="mt-4 font-serif-body text-base sm:text-lg text-white/85 max-w-2xl mx-auto italic">
          {t("noCoperto.sub")}
        </p>
      </div>
    </section>
  );
};
